import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
  TextInput,
  FlatList,
  ScrollView,
  Alert,
} from "react-native";
import Modal from "modal-react-native-web";
import { Octicons } from "@expo/vector-icons";
import { getCoupons } from "../../action/actionGet";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { useIsFocused, useNavigation } from "@react-navigation/core";
import moment from "moment";
import { apiservice } from "../../service/service";
const { width, height } = Dimensions.get("window");

const ModalDelete = ({
  state,
  modals,
  setModal,
  deleteMessage,
  setDeleteMessage,
  token,
}) => {
  return (
    <Modal
      animationType="slide"
      transparent={true}
      visible={modals}
      onRequestClose={() => {
        Alert.alert("Modal has been closed.");
        setModal(!modals);
      }}
    >
      <View style={styles.backmodal}>
        <View style={styles.viewmodal}>
          <Text style={styles.textdel}>
            พิมพ์คำว่า DELETE แล้วกดปุ่มยืนยัน เพื่อต้องการลบ ID นี้
          </Text>
          <TextInput
            value={deleteMessage}
            onChangeText={setDeleteMessage}
            style={styles.inputmodal}
          />
          <View
            style={{
              flexDirection: "row",
              marginTop: 20,
              alignSelf: "flex-end",
            }}
          >
            <TouchableOpacity
              onPress={() => setModal(!modals)}
              style={styles.touchadd1}
            >
              <Text style={styles.textadd}>ยกเลิก</Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={async () => {
                const res = await apiservice({
                  path: "/coupon/delete-coupon/" + state?.id,
                  method: "delete",
                  body: {
                    id: state?.id,
                  },
                  token: token?.accessToken,
                });

                if (res.status == 200) {
                  window.location.reload();
                  setModal(!modals);
                }
              }}
              style={[styles.touchadd1, { marginHorizontal: 25 }]}
            >
              <Text style={styles.textadd}>ยืนยัน</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default function page1({ eventId, isSuperAdmin }) {
  const navigation = useNavigation();
  const focus = useIsFocused();
  const token = useRecoilValue(tokenState);
  const [state, setState] = useState();
  const [deletes, setDelete] = useState("");
  const [modals, setModal] = useState(false);
  const [event, setEvents] = useState([]);

  // Function to get package distance by packageId
  const getPackageDistance = (eventDetails, packageId) => {
    if (!eventDetails?.distance || !packageId) return "-";

    const packages = eventDetails.distance.map((item, index) => ({
      ...item,
      id: index,
    }));
    const foundPackage = packages.find(
      (pkg) => `${pkg.distance}:${pkg.id}` === packageId,
    );

    return foundPackage?.distance ?? "-";
  };

  async function allEvent(eventId) {
    const results = await getCoupons(token, 1, 10000);

    if (results.status == 200) {
      const newData = results.data.data || [];

      let filteredData = newData;
      if (eventId) {
        filteredData = newData.filter((item) => item.id == eventId);
      }

      setEvents(filteredData);
    }
  }

  useEffect(() => {
    setEvents([]);
    allEvent(eventId);
  }, [token, focus, eventId]);

  return (
    <View style={styles.back}>
      <ModalDelete
        state={state}
        modals={modals}
        setModal={setModal}
        deleteMessage={deletes}
        setDeleteMessage={setDelete}
        token={token}
      />

      <View style={{ height: height * 0.65 }}>
        <ScrollView horizontal contentContainerStyle={{ paddingBottom: 60 }}>
          <FlatList
            data={event}
            contentContainerStyle={{ paddingBottom: 60 }}
            ListHeaderComponent={
              <View style={styles.head}>
                <View style={[styles.viewhead, { width: "10%" }]}>
                  <Text style={styles.texthead}>ชื่อรายการ</Text>
                </View>
                <View style={[styles.viewhead, { width: "30%" }]}>
                  <Text style={styles.texthead}>ชื่ออีเวนต์</Text>
                </View>
                <View style={[styles.viewhead, { width: "10%" }]}>
                  <Text style={styles.texthead}>ชื่อแพ็คเกจ</Text>
                </View>
                <View style={[styles.viewhead, { width: "10%" }]}>
                  <Text style={styles.texthead}>Coupon</Text>
                </View>

                <View style={[styles.viewhead, { width: "10%" }]}>
                  <Text style={styles.texthead}>สถานะ</Text>
                </View>
                <View style={[styles.viewhead, { width: "10%" }]}>
                  <Text style={styles.texthead}>ข้อมูล</Text>
                </View>
              </View>
            }
            renderItem={({ index, item }) => {
              return (
                <View
                  style={[
                    styles.viewmain,
                    styles.head,
                    {
                      backgroundColor: index % 2 ? "#F1F2F4" : "#fff",
                      overflow: "hidden",
                    },
                  ]}
                >
                  <TouchableOpacity
                    onPress={() => {
                      if (item.coupon) {
                        navigator.clipboard.writeText(item.coupon);
                        alert("คัดลอก: " + item.coupon);
                      }
                    }}
                    style={[
                      styles.viewdetail,
                      {
                        width: "10%",
                        justifyContent: "flex-start",
                      },
                    ]}
                  >
                    <View>
                      <Text
                        numberOfLines={2}
                        style={[styles.textdeil, { marginLeft: 10 }]}
                      >
                        {item.coupon}
                      </Text>
                    </View>
                  </TouchableOpacity>
                  <TouchableOpacity
                    disabled
                    style={[
                      styles.viewdetail,
                      {
                        width: "30%",
                        justifyContent: "flex-start",
                      },
                    ]}
                  >
                    <View>
                      <Text
                        numberOfLines={2}
                        style={[styles.textdeil, { marginLeft: 10 }]}
                      >
                        {item.subJoinEvent?.event_Listt?.titel ?? "-"}
                      </Text>
                    </View>
                  </TouchableOpacity>
                  <TouchableOpacity
                    disabled
                    style={[
                      styles.viewdetail,
                      {
                        width: "10%",
                        justifyContent: "flex-start",
                      },
                    ]}
                  >
                    <View>
                      <Text
                        numberOfLines={2}
                        style={[styles.textdeil, { marginLeft: 10 }]}
                      >
                        {item.subJoinEvent?.packages?.title ?? "-"}
                      </Text>
                    </View>
                  </TouchableOpacity>
                  <View style={[styles.viewdetail, { width: "10%" }]}>
                    <Octicons
                      name="dot-fill"
                      size={16}
                      color={item.isUsed == true ? "#2DCE98" : "red"}
                      style={{ alignSelf: "center", marginRight: 10 }}
                    />
                    {item.isUsed == true ? (
                      <Text style={styles.textdate}>ใช้แล้ว</Text>
                    ) : (
                      <Text style={styles.textdate}>ยังไม่ใช้</Text>
                    )}
                  </View>

                  <View style={[styles.viewdetail, { width: "10%" }]}>
                    <Octicons
                      name="dot-fill"
                      size={16}
                      color={item.isVip == true ? "#ffd500" : "black"}
                      style={{ alignSelf: "center", marginRight: 10 }}
                    />
                    {item.isVip === true ? (
                      <Text style={styles.textdate}>VIP</Text>
                    ) : (
                      <Text style={styles.textdate}>ไม่ใช่ VIP</Text>
                    )}
                  </View>

                  <View style={[styles.viewdetail, { width: "10%" }]}>
                    <TouchableOpacity
                      disabled={isSuperAdmin ? false : true}
                      onPress={() => {
                        setState(item);
                        setModal(true);
                      }}
                      style={[styles.touchedit, { marginLeft: 15 }]}
                    >
                      <Text style={[styles.texthead, { fontSize: 14 }]}>
                        DELETE
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              );
            }}
          />
        </ScrollView>
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  back: {
    width: "100%",
    height: "80%",
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
  },
  head: {
    width: 1550,
    height: 50,
    paddingHorizontal: 10,
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
    justifyContent: "space-between",
  },
  viewhead: {
    paddingLeft: 10,
    justifyContent: "center",
  },
  texthead: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewdetail: {
    flexDirection: "row",
    justifyContent: "center",
  },
  img: {
    width: "20%",
    height: 60,
    zIndex: 99,
  },
  textdeil: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#393939",
    marginTop: 5,
  },
  textdetail: {
    fontFamily: "Prompt-Regular",
    fontSize: 12,
    color: "#393939",
  },
  viewmain: {
    flexDirection: "row",
    width: "100%",
    height: 80,
  },
  textdate: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewatc: {
    width: width * 0.18,
    height: 30,
    justifyContent: "space-between",
    alignSelf: "flex-end",
    marginBottom: 20,
    flexDirection: "row",
    marginRight: 20,
  },
  touchatc: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    justifyContent: "center",
  },
  textatc: {
    fontFamily: "Prompt-Regular",
    fontSize: 15,
    color: "#7764E4",
    alignSelf: "center",
  },
  touchedit: {
    width: 80,
    height: 30,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    alignSelf: "center",
    justifyContent: "center",
    // marginLeft: -80,
  },

  viewfree: {
    justifyContent: "space-between",
    width: width * 0.82,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    alignSelf: "center",
  },
  touchadd1: {
    width: 150,
    height: 40,
    justifyContent: "center",
    alignSelf: "center",
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewfor: {
    width: width * 0.55,
    height: 150,
    backgroundColor: "#FFF",
    padding: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    borderRadius: 10,
  },
  textname: {
    fontSize: 18,
    color: "#000000",
    fontFamily: "Prompt-Regular",
  },
  textname1: {
    fontSize: 16,
    color: "#444444",
    fontFamily: "Prompt-Regular",
  },
  textname2: {
    fontSize: 16,
    color: "#000",
    fontFamily: "Prompt-Regular",
  },
  textdate: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  textfree2: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    marginTop: 10,
  },
  view: {
    width: width * 0.82,
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
    paddingHorizontal: 10,
    paddingVertical: 20,
    borderRadius: 10,
  },
  viewmainfor: {
    flexDirection: "row",
    width: width * 0.3,
    justifyContent: "space-between",
  },
  inputadd: {
    width: width * 0.16,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginBottom: 10,
  },
  inputadd1: {
    width: width * 0.16,
    height: 100,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginBottom: 10,
  },
  viewevent: {
    width: width * 0.2,
    height: 100,
    backgroundColor: "#fff",
    borderRadius: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    padding: 20,
  },
  imgicon: {
    width: 50,
    height: 50,
    alignSelf: "flex-end",
    justifyContent: "center",
    borderRadius: 25,
    marginTop: -50,
  },
  text: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#8898AA",
  },
  text1: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#4D4F5C",
  },
  backmodal: {
    flex: 1,
    backgroundColor: "#000000bb",
    justifyContent: "center",
  },
  viewmodal: {
    width: width * 0.7,
    height: 250,
    backgroundColor: "#fff",
    borderRadius: 5,
    alignSelf: "center",
    padding: 10,
  },
  textdel: {
    fontFamily: "Prompt-Regular",
    fontSize: 35,
    color: "#000",
    alignSelf: "center",
  },
  inputmodal: {
    width: width * 0.65,
    height: 50,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginVertical: 10,
    alignSelf: "center",
  },
});
